import { request } from "@/utils/request";
import { IP } from "../config";
/**
 * 查询机器人信息和企业信息
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/mobile/robot/select`,
    method: "POST",
    data,
  });
}
